import React from 'react';
import { observer } from 'mobx-react';

function EmailAttachmentHover({ isHoveringOnAttachment, attachment }) {
    return (
        <div
            className="email-attachment-hover"
            style={{
                visibility: isHoveringOnAttachment ? 'visible' : 'hidden',
            }}
        >
            {attachment.href}
        </div>
    );
}

export default observer(EmailAttachmentHover);
